import { requestNetworkDetails } from "@shared/api/external";

export const getNetworkDetails = () => requestNetworkDetails();
